import { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Form from "react-bootstrap/Form";
import { FormikErrors, useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { jobCategoryApi, JobPostApi, jobTypeApi } from "../../service/apis/employer.api";
import { AppRoute } from "../../router/routerConstants";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
//import { WithContext as ReactTags } from "react-tag-input";
import { TagsInput } from "react-tag-input-component";
import { ButtonLoader } from "../../common/Loader/loader";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; 
import { validationPostJob } from "../../validation/validator";

const EmpPostajobScreen = () => {
  type FieldRefs = {
    [key: string]: React.RefObject<any>;
  };

  const [jobCategory, setJobCategory] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const { state } = useLocation();
  const [NavigateTo] = useCustomNavigate();
  const [isLoading, setIsLoading] = useState(false);

  // const sanitizeOptions = {
  //   // allowedTags: [ 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li', 'p', 'br', 'span', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6' ],
  //   allowedTags: [],
  //   allowedAttributes: {
  //     a: ["href", "name", "target"],
  //     span: ["class"],
  //   },
  //   allowedSchemes: ["http", "https", "mailto"],
  // };
  // 10-12-24
  const fieldRefs: FieldRefs = {
    jobTitle: useRef(null),
    jobCategory: useRef(null),
    jobType: useRef(null),
    salaryStart: useRef(null),
    salaryEnd: useRef(null),
    Experience: useRef(null),
    Qualification: useRef(null),
    Skills: useRef(null),
    Vacancies: useRef(null),
    jobLocation: useRef(null),
    applicationDate: useRef(null),
    jobDescription: useRef(null),
    Responsibilities: useRef(null),
    skillDes: useRef(null),
  };

  const registerStep4Formik = useFormik({
    initialValues: {
      jobTitle: state?.jobTitle || "",
      jobCategory: state?.jobCategory || "",
      jobType: state?.jobType || "",
      salaryStart: state?.salaryStart || "",
      salaryEnd: state?.salaryEnd || "",
      Experience: state?.Experience || "",
      Qualification: state?.Qualification || "",
      Skills: state?.Skills || [],
      Vacancies: state?.Vacancies || "",
      jobLocation: state?.jobLocation || "",
      applicationDate: state?.applicationDate || "",
      jobDescription: state?.jobDescription || "",
      Responsibilities: state?.Responsibilities || "",
      skillDes: state?.skillDes || "",
    },
    // validationSchema: validationPostJob,
    validateOnChange: true,
    validateOnBlur: true,
    validate: async (values): Promise<FormikErrors<typeof values>> => {
    try {
      await validationPostJob.validate(values, { abortEarly: false });
      return {};
    } catch (err) {
      const errors: FormikErrors<typeof values> = {};

      if (err instanceof yup.ValidationError && err.inner) {
        err.inner.forEach((e) => {
          if (e.path && !errors[e.path as keyof typeof values]) {
            errors[e.path as keyof typeof values] = e.message;
          }
        });

        // Scroll to first error field
        const firstErrorField = Object.keys(errors)[0];
        const ref = fieldRefs[firstErrorField as keyof typeof fieldRefs];
        if (ref && ref.current && errors) {
          ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
          // ref.current.focus();
        }
      }

      return errors;
    }
  },
    onSubmit: async (values) => {
      const skillsAsString = values.Skills.join(", ");
      try {
        setIsLoading(true);
        //let description = values.jobDescription,
        //sanitizedDescription = sanitizeHtml(description, sanitizeOptions);

        const bodyData = {
          title: values.jobTitle,
          category: values.jobCategory,
          type: values.jobType,
          salaryMin: values.salaryStart,
          salaryMax: values.salaryEnd,
          experience: values.Experience,
          qualification: values.Qualification,
          skill: skillsAsString,
          des_skills: values.skillDes,
          responsibilities: values.Responsibilities,
          vacancy: values.Vacancies,
          location: values.jobLocation,
          deadlineDate: values.applicationDate,
          description: values.jobDescription,
          //description: sanitizedDescription
        };
        const response = await JobPostApi(bodyData);
        if (response.message === "Job created successfully") {
          toast.success("Job created successfully!!");
          setTimeout(() => {
            NavigateTo(AppRoute.EMPLOYER_MANAGE_JOBS);
          }, 1000);
        } else {
          toast.error("Failed to create job!!");
        }
      } catch (error) {
        toast.error("An error occurred while creating the job!!");
      } finally {
        setIsLoading(false);
      }
    },
  });
  // 10-12-24 ends

  const jobCategoryLists = async() => {
      //setIsLoading(true);
      try {
          const response = await jobCategoryApi();
          setJobCategory(response.categories);
      } catch (error) {
          console.error("Catch Error: ", error);
      } finally {
          //setIsLoading(false);
      }
  };

  const jobTypeLists = async() => {
      //setIsLoading(true);
      try {
          const response = await jobTypeApi();
          setJobType(response.types);
      } catch (error) {
          console.error("Catch Error: ", error);
      } finally {
          //setIsLoading(false);
      }
  };

  useEffect(() => {
    jobCategoryLists();
    jobTypeLists();
  }, []);

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar position-relative p-0">
                <EmployerSidebarScreen />
              </div>

              <div className="col-lg-10 rightcontent p-0">
                <EmployerHeaderScreen />
                <div className="profileJoblisting-holder rightInnerScroll">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="applied-title">
                        <div className="title">
                          <h2>Post A Job</h2>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-10">
                      <Form onSubmit={registerStep4Formik.handleSubmit}>
                        <div className="row">
                          <div className="col-lg-6">
                            {/* <div className="form-group  mb-4"> */}
                            <Form.Group className="form-group mb-4">
                              <Form.Label>Job Title</Form.Label>
                              <Form.Control
                                type="text"
                                ref={fieldRefs.jobTitle}
                                placeholder="Enter job title"
                                name="jobTitle"
                                onChange={registerStep4Formik.handleChange}
                                value={registerStep4Formik.values.jobTitle}
                                isInvalid={
                                  !!registerStep4Formik.errors.jobTitle &&
                                  Boolean(registerStep4Formik.touched.jobTitle)
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {typeof registerStep4Formik.errors.jobTitle ===
                                  "string" && registerStep4Formik.errors.jobTitle}
                              </Form.Control.Feedback>
                            </Form.Group>
                            
                            {/* </div> */}
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group mb-4">
                              <Form.Label>Job Category</Form.Label>
                              <Form.Select
                                ref={fieldRefs.jobCategory}
                                className="form-control"
                                aria-label="Default select example"
                                name="jobCategory"
                                value={registerStep4Formik.values.jobCategory}
                                onChange={registerStep4Formik.handleChange}
                                isInvalid={
                                  !!registerStep4Formik.errors.jobCategory &&
                                  Boolean(
                                    registerStep4Formik.touched.jobCategory
                                  )
                                }
                              >
                                <option value="">Select job category</option>
                                {jobCategory ? ( jobCategory.map((jobCat: any, index: any) => (
                                  <option key={index} value={jobCat.id}>{jobCat.categoryName}</option>
                                  ))):<></>
                                }
                               
                               
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                {typeof registerStep4Formik.errors.jobCategory ===
                                  "string" &&
                                  registerStep4Formik.errors.jobCategory}
                              </Form.Control.Feedback>
                            </Form.Group>
                            
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group  mb-4">
                              <Form.Label>Job Type</Form.Label>
                              <Form.Select
                                className="form-control"
                                ref={fieldRefs.jobType}
                                aria-label="Default select example"
                                name="jobType"
                                value={registerStep4Formik.values.jobType}
                                onChange={registerStep4Formik.handleChange}
                                isInvalid={
                                  !!registerStep4Formik.errors.jobType &&
                                  Boolean(registerStep4Formik.touched.jobType)
                                }
                              >
                                <option value="">Select job type</option>
                                
                                {jobType ? ( jobType.map((jobtpe: any, index: any) => (
                                  <option key={index} value={jobtpe.id}>{jobtpe.typeName}</option>
                                  ))):<></>
                                }
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors.jobType ===
                                "string" && registerStep4Formik.errors.jobType}
                            </Form.Control.Feedback>
                            </Form.Group>
                            
                          </div>
                          <div className="col-lg-3">
                            <Form.Group className="form-group mb-4">
                              <Form.Label>Salary Range</Form.Label>
                              <Form.Control
                                type="number"
                                ref={fieldRefs.salaryStart}
                                placeholder="$00"
                                name="salaryStart"
                                value={registerStep4Formik.values.salaryStart}
                                onChange={registerStep4Formik.handleChange}
                                isInvalid={
                                  !!registerStep4Formik.errors.salaryStart &&
                                  Boolean(
                                    registerStep4Formik.touched.salaryStart
                                  )
                                }
                              />
                               	<Form.Control.Feedback type="invalid">
									{typeof registerStep4Formik.errors.salaryStart ===
										"string" &&
										registerStep4Formik.errors.salaryStart}
								</Form.Control.Feedback>
                            </Form.Group>                         
                          </div>
                          <div className="col-lg-3">
                            <Form.Group className="form-group mb-4">
                              <Form.Label>&nbsp;</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="$00"
                                ref={fieldRefs.salaryEnd}
                                name="salaryEnd"
                                value={registerStep4Formik.values.salaryEnd}
                                onChange={registerStep4Formik.handleChange}
                                onBlur={registerStep4Formik.handleBlur}
                                isInvalid={
                                  !!registerStep4Formik.errors.salaryEnd &&
                                  Boolean(registerStep4Formik.touched.salaryEnd)
                                }
                              />
							  	<Form.Control.Feedback type="invalid">
									{typeof registerStep4Formik.errors.salaryEnd ===
										"string" &&
										registerStep4Formik.errors.salaryEnd}
								</Form.Control.Feedback>
                            </Form.Group>                            
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group  mb-4">
                              <Form.Label>Job Experience</Form.Label>
                              <Form.Select
                                className="form-control"
                                aria-label="Default select example"
                                ref={fieldRefs.Experience}
                                name="Experience"
                                value={registerStep4Formik.values.Experience}
                                onChange={registerStep4Formik.handleChange}
                                onBlur={registerStep4Formik.handleBlur}
                                isInvalid={
                                  !!registerStep4Formik.errors.Experience &&
                                  Boolean(
                                    registerStep4Formik.touched.Experience
                                  )
                                }
                              >
                                <option value="">Select job experience</option>
                                <option value="1 - 3 years">1 - 3 years</option>
                                <option value="3 - 5 years">3 - 5 years</option>
                                <option value="5 - 10 years">5 - 10 years</option>
                              </Form.Select>
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors.Experience ===
                                "string" &&
                                registerStep4Formik.errors.Experience}
                            </Form.Control.Feedback>
                            </Form.Group>                            
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group mb-4">
                              <Form.Label>Qualification</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter qualification"
                                ref={fieldRefs.Qualification}
                                name="Qualification"
                                onChange={registerStep4Formik.handleChange}
                                value={registerStep4Formik.values.Qualification}
                                isInvalid={
                                  !!registerStep4Formik.errors.Qualification &&
                                  Boolean(
                                    registerStep4Formik.touched.Qualification
                                  )
                                }
                              />
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors
                                .Qualification === "string" &&
                                registerStep4Formik.errors.Qualification}
                            </Form.Control.Feedback>
                            </Form.Group>                            
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group mb-4">
                              	<Form.Label>
									Skill Required{" "}
									<span className="text-danger">
									( Press Enter after entering a value. )
									</span>
                              	</Form.Label>

								<div className={registerStep4Formik.errors.Skills && "is-invalid"}
                  ref={fieldRefs.Skills}
                >
									<TagsInput
										value={registerStep4Formik.values.Skills}
										onChange={(value) =>
											registerStep4Formik.setFieldValue(
												"Skills",
												value
											)
										}
										//onChange={(newTags) => setSkills("Skills", newTags)}
										name="Skills"
										placeHolder="Add skills"
									/>
								</div>

								{registerStep4Formik.errors.Skills && (
									<div className="invalid-feedback">
									{/* {registerStep4Formik.errors.Skills} */}
									{typeof registerStep4Formik.errors.Skills ==="string" && registerStep4Formik.errors.Skills}
									</div>
								)}

								{/* <Form.Control.Feedback type="invalid">
									{typeof registerStep4Formik.errors.Skills ==="string" && registerStep4Formik.errors.Skills}
								</Form.Control.Feedback> */}

                            </Form.Group>                            
                          </div>

                          <div className="col-lg-6">
                            <Form.Group className="form-group mb-4">
                              <Form.Label>Number of Vacancies</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Enter number of vacancies"
                                name="Vacancies"
                                onChange={registerStep4Formik.handleChange}
                                onBlur={registerStep4Formik.handleBlur}
                                value={registerStep4Formik.values.Vacancies}
                                isInvalid={
                                  !!registerStep4Formik.errors.Vacancies &&
                                  Boolean(registerStep4Formik.touched.Vacancies)
                                }
                                ref={fieldRefs.Vacancies}
                              />
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors.Vacancies ===
                                "string" &&
                                registerStep4Formik.errors.Vacancies}
                            </Form.Control.Feedback>
                            </Form.Group>

                            
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group mb-4">
                              <Form.Label>Job Location</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Job Location"
                                name="jobLocation"
                                onChange={registerStep4Formik.handleChange}
                                onBlur={registerStep4Formik.handleBlur}
                                value={registerStep4Formik.values.jobLocation}
                                isInvalid={
                                  !!registerStep4Formik.errors.jobLocation &&
                                  Boolean(
                                    registerStep4Formik.touched.jobLocation
                                  )
                                }
                                ref={fieldRefs.jobLocation}
                              />
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors.jobLocation ===
                                "string" &&
                                registerStep4Formik.errors.jobLocation}
                            </Form.Control.Feedback>
                            </Form.Group>

                            
                          </div>
                          <div className="col-lg-6">
                            <Form.Group className="form-group mb-4">
                              <Form.Label>Application Deadline Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Enter application date"
                                name="applicationDate"
                                onChange={registerStep4Formik.handleChange}
                                onBlur={registerStep4Formik.handleBlur}
                                value={
                                  registerStep4Formik.values.applicationDate
                                }
                                isInvalid={
                                  !!registerStep4Formik.errors
                                    .applicationDate &&
                                  Boolean(
                                    registerStep4Formik.touched.applicationDate
                                  )
                                }
                                ref={fieldRefs.applicationDate}
                              />
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors
                                .applicationDate === "string" &&
                                registerStep4Formik.errors.applicationDate}
                            </Form.Control.Feedback>
                            </Form.Group>

                            
                          </div>
                          <div className="col-lg-12">
                            {/* <Form.Group className="form-group mb-4">
                              <Form.Label>Job Description</Form.Label>
                              <Editor
                                id="jobDescription"
                                apiKey="tdr5u3hs5sq6n7v1xnf9w3e12tfsg3yeroch75k8gegz39nb"
                                init={{
                                  height: 300,
                                  menubar: false,
                                  plugins:
                                    "preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen link table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion",
                                  toolbar:
                                    "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | pagebreak anchor codesample | ltr rtl",
                                  placeholder: "Enter job description here...",
                                  block_formats:
                                    "Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3",
                                }}
                                value={
                                  registerStep4Formik.values.jobDescription
                                }
                                onEditorChange={(content) => {
                                  registerStep4Formik.setFieldValue(
                                    "jobDescription",
                                    content
                                  );
                                  registerStep4Formik.setFieldTouched(
                                    "jobDescription",
                                    true
                                  );
                                }}
                              />
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors
                                .jobDescription === "string" &&
                                registerStep4Formik.errors.jobDescription}
                            </Form.Control.Feedback>
                            </Form.Group> */}

							{/* New Quill */}
							<Form.Group className="form-group mb-4">
								<Form.Label>Job Description</Form.Label>
								<ReactQuill
									theme="snow"
                  ref={fieldRefs.jobDescription}
									value={registerStep4Formik.values.jobDescription}
									onChange={(content) => {
										registerStep4Formik.setFieldValue("jobDescription", content);
										registerStep4Formik.setFieldTouched("jobDescription", true);
									}}
									placeholder="Enter job description here..."
									style={{ height: "200px", marginBottom: "40px" }}
									modules={{
										toolbar: [
											[{ header: [1, 2, 3, false] }],
										  	["bold", "italic", "underline", "strike"],
										  	[{ list: "ordered" }, { list: "bullet" }],
										  	["link", "blockquote", "code-block"],
										  	[{ color: [] }, { background: [] }],
											[{ align: [] }],
											[{ font: [] }],
										  	["clean"],
										],
									}}
									formats={[
										"header",
										"bold",
										"italic",
										"underline",
										"strike",
										"list",
										"bullet",
										"link",
										"blockquote",
										"code-block",
										"color",
										"background",
									]}
								/>
								{registerStep4Formik.touched.jobDescription &&
								registerStep4Formik.errors.jobDescription && (
									<Form.Control.Feedback type="invalid">
										{typeof registerStep4Formik.errors.jobDescription === "string" && registerStep4Formik.errors.jobDescription}
									</Form.Control.Feedback>
								)}
							</Form.Group>
							{/* New Quill ends */}

                            
                          </div>

                          <div className="col-lg-12">
							{/* Old TinyMCE */}
                            {/* <Form.Group className="form-group mb-4">
                              <Form.Label>Responsibilities</Form.Label>
                              <Editor
                                id="Responsibilities"
                                apiKey="tdr5u3hs5sq6n7v1xnf9w3e12tfsg3yeroch75k8gegz39nb"
                                init={{
                                  height: 300,
                                  menubar: false,
                                  plugins:
                                    "preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen link table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion",
                                  toolbar:
                                    "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | pagebreak anchor codesample | ltr rtl",
                                  placeholder: "Enter job description here...",
                                }}
                                value={
                                  registerStep4Formik.values.Responsibilities
                                }
                                onEditorChange={(content) => {
                                  registerStep4Formik.setFieldValue(
                                    "Responsibilities",
                                    content
                                  );
                                  registerStep4Formik.setFieldTouched(
                                    "Responsibilities",
                                    true
                                  );
                                }}
                              />
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors
                                .Responsibilities === "string" &&
                                registerStep4Formik.errors.Responsibilities}
                            </Form.Control.Feedback>
                            </Form.Group> */}
							{/* Old TinyMCE ends */}

							{/* New Quill */}
							<Form.Group className="form-group mb-4">
								<Form.Label>Responsibilities and Duties</Form.Label>
								<ReactQuill
									theme="snow"
                  ref={fieldRefs.Responsibilities}
									value={registerStep4Formik.values.Responsibilities}
									onChange={(content) => {
										registerStep4Formik.setFieldValue("Responsibilities", content);
										registerStep4Formik.setFieldTouched("Responsibilities", true);
									}}
									placeholder="Enter Responsibilities and Duties here..."
									style={{ height: "200px", marginBottom: "40px" }}
									modules={{
										toolbar: [
											[{ header: [1, 2, 3, false] }],
										  	["bold", "italic", "underline", "strike"],
										  	[{ list: "ordered" }, { list: "bullet" }],
										  	["link", "blockquote", "code-block"],
										  	[{ color: [] }, { background: [] }],
											[{ align: [] }],
											[{ font: [] }],
										  	["clean"],
										],
									}}
									formats={[
										"header",
										"bold",
										"italic",
										"underline",
										"strike",
										"list",
										"bullet",
										"link",
										"blockquote",
										"code-block",
										"color",
										"background",
									]}
								/>
								{registerStep4Formik.touched.Responsibilities &&
								registerStep4Formik.errors.Responsibilities && (
									<Form.Control.Feedback type="invalid">
										{typeof registerStep4Formik.errors.Responsibilities === "string" && registerStep4Formik.errors.Responsibilities}
									</Form.Control.Feedback>
								)}
							</Form.Group>
							{/* New Quill ends */}
                          </div>

                          <div className="col-lg-12">
                            {/* <Form.Group className="form-group mb-4">
                              <Form.Label>Skills Description</Form.Label>
                              <Editor
                                id="skillDes"
                                apiKey="tdr5u3hs5sq6n7v1xnf9w3e12tfsg3yeroch75k8gegz39nb"
                                init={{
                                  height: 300,
                                  menubar: false,
                                  plugins:
                                    "preview importcss searchreplace autolink directionality code visualblocks visualchars fullscreen link table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons accordion",
                                  toolbar:
                                    "undo redo | accordion accordionremove | blocks fontfamily fontsize | bold italic underline strikethrough | align numlist bullist | link | table media | lineheight outdent indent| forecolor backcolor removeformat | charmap emoticons | code fullscreen preview | pagebreak anchor codesample | ltr rtl",
                                  placeholder: "Enter job description here...",
                                }}
                                value={registerStep4Formik.values.skillDes}
                                onEditorChange={(content) => {
                                  registerStep4Formik.setFieldValue(
                                    "skillDes",
                                    content
                                  );
                                  registerStep4Formik.setFieldTouched(
                                    "skillDes",
                                    true
                                  );
                                }}
                              />
							  <Form.Control.Feedback type="invalid">
                              {typeof registerStep4Formik.errors.skillDes ===
                                "string" && registerStep4Formik.errors.skillDes}
                            </Form.Control.Feedback>
                            </Form.Group> */}

							{/* New Quill */}
							<Form.Group className="form-group mb-4">
								<Form.Label>Required Experience, Skills and Qualifications</Form.Label>
								<ReactQuill
									theme="snow"
									value={registerStep4Formik.values.skillDes}
									onChange={(content) => {
										registerStep4Formik.setFieldValue("skillDes", content);
										registerStep4Formik.setFieldTouched("skillDes", true);
									}}
                  ref={fieldRefs.skillDes}
									placeholder="Enter Required Experience, Skills and Qualifications here..."
									style={{ height: "200px", marginBottom: "40px" }}
									modules={{
										toolbar: [
											[{ header: [1, 2, 3, false] }],
										  	["bold", "italic", "underline", "strike"],
										  	[{ list: "ordered" }, { list: "bullet" }],
										  	["link", "blockquote", "code-block"],
										  	[{ color: [] }, { background: [] }],
											[{ align: [] }],
											[{ font: [] }],
										  	["clean"],
										],
									}}
									formats={[
										"header",
										"bold",
										"italic",
										"underline",
										"strike",
										"list",
										"bullet",
										"link",
										"blockquote",
										"code-block",
										"color",
										"background",
									]}
								/>
								{registerStep4Formik.touched.skillDes &&
								registerStep4Formik.errors.skillDes && (
									<Form.Control.Feedback type="invalid">
										{typeof registerStep4Formik.errors.skillDes === "string" && registerStep4Formik.errors.skillDes}
									</Form.Control.Feedback>
								)}
							</Form.Group>
							{/* New Quill ends */}

                            
                          </div>

                          <div className="col-lg-12">
                            <div className="form-group">
                              <Button className="btn" type="submit">
                                {isLoading ? <ButtonLoader /> : " Post The Job"}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <Modal.Body>
          <div className="afterapplied">
            <h3>Customer Care Executive</h3>
            <div className="aplyinfo">
              <h4>
                <strong>Job Title:</strong> Customer Care Executive
              </h4>
              <h4>
                <strong>Company Name:</strong> TechWave Solutions
              </h4>
              <h4>
                <strong>Location:</strong> San Francisco, CA
              </h4>
              <h4>
                <strong>Application Date:</strong> Oct 12, 2024
              </h4>
              <h4>
                <strong>Job Type:</strong> Full-time
              </h4>
              <h4>
                <strong>Status:</strong> Applied
              </h4>
              <h4>
                <strong>Salary Range:</strong> $900 - $1200/month
              </h4>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default EmpPostajobScreen;
